import React, { useState, useEffect, useContext } from "react";
import { Content, Container, TryAgain } from "../styles";

import NotFound from "../../../../components/notFound/notFound";

import ReturnButton from "../components/ReturnButton";
import StatusPayment from "../components/StatusPayment";
import TransactionDetails from "../components/TransactionDetail";
import PurchaseDetail from "../components/PurchaseDetail";

import failureImg from "../../../../assets/images/failure.svg";

const Falha = (props) => {
  const pageId = props.location.state?.id;
  const count = props.location.state?.count;
  const transaction_response_message = {
    message: props.location.state?.message,
    response: props.location.state?.response_message
  };
  const payment_detail = props.location.state?.payment_detail;
  const transaction_detail = props.location.state?.transaction_detail;
  const style_page = props.location.state?.style_page;

  // const message = "A mensagem virá aqui";

  // const payment_detail = {
  //   payment_amount: "3000",
  //   authorizer_id: "255",
  //   payment_type: "C",
  //   payment_date: "28/02/2023T16:31",
  //   transaction_code: "2f2f0607fe481ae318e2d06d9d55ed543026afedf0f26b3151ac901473aab8fa",
  // };

  // const transaction_detail = {
  //   order: "100000000001",
  //   product_detail: {
  //     discount: {
  //       type: "amount",
  //       value: 100,
  //     },
  //     items: [
  //       {
  //         product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "PS5",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 400,
  //         quantity: 1,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //       {
  //         // product_sku: "SDE000123",
  //         product_type: 5,
  //         product_name: "Iphone",
  //         product_description: "Iphone 15, Tela de 6,1 polegadas, cor meia noite,armazenamento 1TB",
  //         description_view: true,
  //         product_price: 188155,
  //         quantity: 6,
  //         units: 120,
  //         weight: 400,
  //         expiration_date: "2022-10-31",
  //       },
  //     ],
  //   },
  //   shipping_detail: {
  //     type: "correios",
  //     delivery_price: "4200",
  //     delivery_time: 4,
  //   },
  // };

  // const style_page = {
  //   background_color: ""
  // }

  const [stage, setStage] = useState(0);

  const statusData = {
    transactionStatus: {
      image: failureImg,
      title: "Ops... Falha no pagamento!",
      message:
        "Houve um problema com o processamento do pagamento e a transação não pode ser concluída. Por favor, verifique se os dados de seu pagamento estão corretos e tente novamente. Se o problema persistir, entre em contato com o banco ou instituição emissora do seu cartão para obter assistência.",
    },
    paymentStatus: {
      status: "failure",
      message: "Falha no pagamento",
    },
  };

  useEffect(() => {

    // setStage(1);

    if (props.location.state) {
      setStage(1);
    } else {
      // Página de não encontrado
      setStage(2);
    }

  }, []);

  const returnPage = () => {
    props.history.push(`/link/${pageId}`, {count: count + 1} );
  };

  return (
    <>
      {stage === 1 && (
        <Content bgColor={style_page.background_color || "#E5E5E5"}>
          <Container id="status-payment">
            <StatusPayment
              transactionStatus={statusData.transactionStatus}
              styledPage={style_page}
              responseMessage={transaction_response_message}
            />
          </Container>

          <Container className="other-containers">
            <TransactionDetails
              paymentStatus={statusData.paymentStatus}
              paymentData={payment_detail}
              reiceptButtonColor={style_page.background_color}
            />
          </Container>

          <Container className="other-containers">
            <PurchaseDetail shippingData={transaction_detail} amount={payment_detail.amount} />
            <TryAgain>
              <ReturnButton bgColor={style_page.background_color} handleBack={returnPage}/>
            </TryAgain>
          </Container>
        </Content>
      )}
      {stage === 2 && (
        <>
          <NotFound />
        </>
      )}
    </>
  );
};

export default Falha;
